module.exports = __webpack_public_path__ + "img/610.d956c4be.png";